/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { UniqueConstraintConfig } from "./UniqueConstraintConfig";
export const UniqueConstraint = core.serialization.object({
    config: UniqueConstraintConfig.optional(),
});
